import React, { useEffect, useState } from 'react';
import { NavLink as Link, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

import { saveAs } from 'file-saver';

import Header from '../../common/components/Header';
import Nav from '../../common/components/Nav';
import Footer from '../../common/components/Footer';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { findPublishedPublication } from "../../utils/api/publication";
import { errorHandler } from "../../utils/helpers/errorHandler";
import { setPublicationToBeVisualized } from "../../store/actions/actions/publication";
import DownloadApp from '../../common/components/DownloadApp';

const PublicationsPage = () => {
  const rootUrl = `${process.env.REACT_APP_ROOT_URL}`;
  const SIZE_PER_PAGE = `${process.env.REACT_APP_SIZE_PER_PAGE}` === "undefined"
    ? 20 : `${process.env.REACT_APP_SIZE_PER_PAGE}`;

  const history = useHistory(),
        dispatch = useDispatch();
  
  const [page, setPage] = useState(0),
        [maxPage, setMaxPage] = useState(SIZE_PER_PAGE),
        [publications, setPublications] = useState([]),
        [showPageLoader, setShowPageLoader] = useState(true);

  useEffect(() => {
    handleFetchPublishedPublication();
  }, []);

  const handleFetchPublishedPublication = async (page = 0) => {
    setShowPageLoader(true);
    try {
      const data = await findPublishedPublication(page);

      setPage(data.page);
      setMaxPage(data.count);
      setPublications(data.allPublications);
      setShowPageLoader(false);
    } catch (error) {
      setShowPageLoader(false);
      errorHandler(error, toast);
    }
  }

  const handleViewPublication = (data) => {
    dispatch(setPublicationToBeVisualized(data));
    history.push(`/publications/${data.uuid}/view`);
  }

  const handleNextPagination = async (event) => {
    event.preventDefault();
    await handleFetchPublishedPublication(+page);
  }

  const handlePreviousPagination = async (event) => {
    event.preventDefault();
    await handleFetchPublishedPublication(page - 2);
  }

  const totalPages = Math.ceil(+maxPage / +SIZE_PER_PAGE) || 1;
  const currentPage = +page || 1;

  return (
    <div
      className="d-flex flex-column min-vh-100"
      style={{
        backgroundColor: "#F8FAFC",
        fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
      }}
    >
      <header className="sticky-top bg-white z-3 border-bottom border-light">
        <Nav />
      </header>

      <section className="flex-grow-1 py-5">
        <div className="container py-2">
          
          {/* Header & Overview */}
          <div className="mb-5 text-center max-w-2xl mx-auto" style={{ maxWidth: "720px" }}>
            <span
              className="badge rounded-pill px-3 py-2 text-uppercase mb-3 fw-semibold"
              style={{
                backgroundColor: "rgba(10, 61, 46, 0.08)",
                color: "#0A3D2E",
                fontSize: "12px",
                letterSpacing: "0.8px",
              }}
            >
              LBS Library
            </span>
            <h1 className="fw-bold text-dark display-5 mb-3" style={{ letterSpacing: "-0.5px" }}>
              Publications
            </h1>
            <p className="text-secondary fs-6 lh-relaxed mb-0">
              Go through our rich library of publications of different activities relating to Ministry of Economic Planning and Budget
            </p>
          </div>

          {/* Cards Grid */}
          <div className="row g-4">
            {publications.length > 0 && !showPageLoader ? (
              publications.map((publication) => (
                <div className="col-lg-4 col-md-6 d-flex" key={publication.uuid}>
                  <div className="__pupli card border-0 rounded-4 bg-white shadow-sm w-100 p-3 d-flex flex-column">
                    
                    {/* Restored exact __latimg div structure */}
                    <div
                      className="__latimg rounded-3 overflow-hidden mb-3"
                      style={{
                        height: "200px",
                        background: publication?.banner.startsWith("/")
                          ? `linear-gradient(360deg, #175C7D 0%, rgba(255, 255, 255, 0) 100%), url(${rootUrl}/${publication.banner.substr(publication.banner.lastIndexOf('/')+1)}) center/cover no-repeat`
                          : `linear-gradient(360deg, #175C7D 0%, rgba(255, 255, 255, 0) 100%), url(${process.env.REACT_APP_ROOT_URL}/uploads/${publication.banner}) center/cover no-repeat`,
                        cursor: "pointer"
                      }}
                      onClick={() => handleViewPublication(publication)}
                    ></div>

                    {/* Content Body */}
                    <div className="__latestcard d-flex flex-column flex-grow-1 px-1">
                      <p
                        className="__latimgp fw-bold text-dark mb-2 lh-snug cursor-pointer fs-6"
                        style={{ minHeight: "44px", letterSpacing: "-0.2px" }}
                        onClick={() => handleViewPublication(publication)}
                      >
                        {publication.title}
                      </p>

                      <p
                        className="__latp text-secondary small lh-relaxed flex-grow-1 mb-4"
                        style={{ color: "#64748B", fontSize: "13px" }}
                      >
                        {publication.body.length > 300
                          ? `${publication.body.substr(0, 300)}...`
                          : publication.body}
                      </p>

                      {/* Pill button action */}
                      <div className="mt-auto pt-2">
                        {publication.file ? (
                          <a
                            href={
                              publication?.file.startsWith('/')
                                ? `${rootUrl}/${publication.file.substr(publication.file.lastIndexOf('/')+1)}`
                                : `${process.env.REACT_APP_ROOT_URL}/uploads/${publication.file}`
                            }
                            target="_blank"
                            rel="noreferrer"
                            className="btn __latbtn text-white rounded-pill px-3 py-2 border-0 small d-inline-flex align-items-center gap-2 fw-medium"
                            style={{
                              backgroundColor: "#0A3D2E",
                              fontSize: "13px",
                            }}
                          >
                            <span>Preview file</span>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                              <line x1="7" y1="17" x2="17" y2="7"></line>
                              <polyline points="7 7 17 7 17 17"></polyline>
                            </svg>
                          </a>
                        ) : (
                          <button
                            onClick={() => handleViewPublication(publication)}
                            className="btn text-white rounded-pill px-3 py-2 border-0 small d-inline-flex align-items-center gap-2 fw-medium"
                            style={{
                              backgroundColor: "#0A3D2E",
                              fontSize: "13px",
                            }}
                          >
                            <span>View Details</span>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                              <line x1="7" y1="17" x2="17" y2="7"></line>
                              <polyline points="7 7 17 7 17 17"></polyline>
                            </svg>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <>
                {!showPageLoader && (
                  <div className="col-12 text-center py-5">
                    <p className="fs-5 text-muted fw-medium mb-0">
                      There are no publications available
                    </p>
                  </div>
                )}
              </>
            )}

            {showPageLoader && (
              <div className="col-12 text-center py-5">
                <div className="d-flex justify-content-center align-items-center">
                  <img src="/assets/img/page-loader.gif" className="icon" alt="Loading..." />
                </div>
              </div>
            )}
          </div>

          {/* Styled Pagination */}
          {!showPageLoader && publications.length > 0 && (
            <div className="__expmia1i mt-5 pt-4 d-flex flex-column flex-sm-row justify-content-between align-items-center gap-3 border-top border-light-subtle">
              <span className="text-secondary small fw-medium">
                Page <strong className="text-dark">{currentPage}</strong> of <strong className="text-dark">{totalPages}</strong>
              </span>

              <div className="d-flex align-items-center gap-2">
                <button
                  onClick={handlePreviousPagination}
                  disabled={currentPage <= 1}
                  className="btn border-0 rounded-pill px-3 py-2 small fw-semibold d-inline-flex align-items-center gap-1"
                  style={{
                    backgroundColor: currentPage <= 1 ? "#E2E8F0" : "#0A3D2E",
                    color: currentPage <= 1 ? "#94A3B8" : "#FFFFFF",
                    cursor: currentPage <= 1 ? "not-allowed" : "pointer",
                    fontSize: "13px",
                  }}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                  <span>Previous</span>
                </button>

                <button
                  onClick={handleNextPagination}
                  disabled={currentPage >= totalPages}
                  className="btn border-0 rounded-pill px-3 py-2 small fw-semibold d-inline-flex align-items-center gap-1"
                  style={{
                    backgroundColor: currentPage >= totalPages ? "#E2E8F0" : "#0A3D2E",
                    color: currentPage >= totalPages ? "#94A3B8" : "#FFFFFF",
                    cursor: currentPage >= totalPages ? "not-allowed" : "pointer",
                    fontSize: "13px",
                  }}
                >
                  <span>Next</span>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>
            </div>
          )}

        </div>
      </section>

      <ToastContainer closeOnClick pauseOnHover />
      <Footer />
    </div>
  );
};

export default PublicationsPage;